import { render, staticRenderFns } from "./life-line.vue?vue&type=template&id=66ab6ebe&scoped=true"
import script from "./life-line.vue?vue&type=script&lang=js"
export * from "./life-line.vue?vue&type=script&lang=js"
import style0 from "./life-line.vue?vue&type=style&index=0&id=66ab6ebe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ab6ebe",
  null
  
)

export default component.exports